import { render, staticRenderFns } from "./OperationItem.vue?vue&type=template&id=08768085&scoped=true"
import script from "./OperationItem.vue?vue&type=script&lang=js"
export * from "./OperationItem.vue?vue&type=script&lang=js"
import style0 from "./OperationItem.vue?vue&type=style&index=0&id=08768085&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08768085",
  null
  
)

export default component.exports